(function(){
  const root = document.getElementById('htb02-nativefinal');
  if (!root) return;

  (function(){
    const dateNode = root.querySelector('#htb02nf-io9yv');
    if (!dateNode) return;
    dateNode.textContent = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'America/New_York'
    }).format(new Date());
  })();

  const sticky = root.querySelector('.htb02nf-sticky');
  if (!sticky) return;

  const triggerText = 'INTRODUCING THE DEVICE THAT ACTUALLY RELIEVES LEG PAIN AT THE SOURCE';
  const trigger = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,div,span,p'))
    .filter(function(el){ return (el.textContent || '').replace(/\s+/g,' ').trim().includes(triggerText); })
    .sort(function(a,b){
      var at=(a.textContent||'').trim().length, bt=(b.textContent||'').trim().length;
      return at-bt;
    })[0] || null;

  sticky.classList.remove('htb02nf-sticky-visible');
  let ticking = false;

  const revealPoint = () => {
    if (!trigger) return Math.min(700, document.documentElement.scrollHeight * 0.25);
    const triggerTop = trigger.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    return Math.max(0, triggerTop - (window.innerHeight * 0.70));
  };

  const update = () => {
    ticking = false;
    const y = window.scrollY || window.pageYOffset || 0;
    const point = revealPoint();
    if (y >= point) sticky.classList.add('htb02nf-sticky-visible');
    else if (y < point - 400) sticky.classList.remove('htb02nf-sticky-visible');
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();
})();
